import * as v from 'valibot'

export const GameCatalogQuery = v.strictObject({
  locale: v.optional(v.picklist(['en', 'zh', 'zh-CN', 'ja', 'ko', 'es', 'pt']), 'en'),
  q: v.optional(v.pipe(v.string(), v.trim(), v.maxLength(200)), ''),
  genre: v.optional(v.pipe(v.string(), v.trim(), v.maxLength(100)), ''),
  sort: v.optional(v.picklist(['featured', 'popular', 'latest']), 'popular'),
  game_type: v.optional(v.picklist(['all', 'story', 'scenario']), 'all'),
  catalog_ids: v.optional(v.pipe(v.string(), v.maxLength(4000))),
  cursor: v.optional(v.pipe(v.string(), v.maxLength(2000))),
  limit: v.optional(v.pipe(v.union([v.number(), v.string()]), v.transform(Number), v.integer(), v.minValue(1), v.maxValue(50)), 12),
})

export const GameCatalogItem = v.object({
  catalog_id: v.string(),
  game_type: v.picklist(['story', 'scenario']),
  source_id: v.string(),
  slug: v.nullable(v.string()),
  title: v.string(),
  summary: v.string(),
  cover_url: v.nullable(v.string()),
  genres: v.array(v.string()),
  author: v.nullable(v.object({ id: v.string(), name: v.string(), avatar_url: v.nullable(v.string()) })),
  detail_href: v.string(),
  play_href: v.string(),
  play_state: v.picklist(['available', 'coming_soon', 'unavailable']),
  published_at: v.nullable(v.string()),
  play_count: v.number(),
})

export const GameCatalogPage = v.object({
  items: v.array(GameCatalogItem),
  next_cursor: v.nullable(v.string()),
  has_more: v.boolean(),
})

export const parseGameCatalogPage = value => v.parse(GameCatalogPage, value)

/** Both repositories and the merger use ascending rank, descending metric, binary ID. */
export function compareGameCatalogCandidates(left, right) {
  return left.sort_rank - right.sort_rank || right.sort_value - left.sort_value
    || (left.catalog_id < right.catalog_id ? -1 : left.catalog_id > right.catalog_id ? 1 : 0)
}
